import React, { Component } from 'react';
import { ErrorMessage, Field, getIn } from 'formik';
import ItemFormCustomSelect from '../../../../common/formElements/ItemFormCustomSelect';

class StaticOptions extends Component {
  requiredValidate = (value) => {
    if (this.props.isConstructorForm) {
      return;
    }
    const { required } = this.props.field;
    let error;
    if (required && (!value || value.length === 0)) {
      error = 'This field is required';
    }
    return error;
  };

  staticOptions = () => {
    const { staticOptions } = this.props.field;
    let options = [];
    if (staticOptions) {
      options = staticOptions.map((item) => {
        let itemLabel = item;
        let itemValue = item;
        if (item && item.includes('::')) {
          const itemArr = item.split('::');
          if (itemArr && itemArr.length === 2) {
            itemValue = itemArr[0].trim();
            itemLabel = itemArr[1].trim();
          }
        }
        return {
          value: itemValue,
          label: itemLabel,
        };
      });
    }
    return [{ value: '', label: '-- Select Value --' }].concat(options);
  };

  render() {
    const { field, values, isConstructorForm } = this.props;
    const { fieldTitle, required, fieldName, type, isMultiSelect } = field;
    const fieldValue = getIn(values, fieldName);
    return (
      <>
        <Field
          as={ItemFormCustomSelect}
          name={fieldName}
          isMulti={isMultiSelect}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          options={this.staticOptions().length > 0 ? this.staticOptions() : []}
          placeholder={`Please select an ${fieldTitle['en']}`}
          value={fieldValue || []}
          validate={this.requiredValidate}
          title={fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={fieldName} />
        </p>
      </>
    );
  }
}

export default StaticOptions;
